import { useDocsDataModelStore } from '@/models/docs-data/docsData';
import { CustomApiBuiltInField } from '@/shared/constant/CustomApiBuiltInField';
import React from 'react';

export function useIsShowRequestSampleCode() {
  const displayFieldIds = useDocsDataModelStore((x) => x.docsBaseConfig.displayFieldIds);

  const isShowRequestSampleCode = React.useMemo(() => {
    return displayFieldIds.includes(CustomApiBuiltInField.CODE_SAMPLE);
  }, [displayFieldIds]);

  return isShowRequestSampleCode;
}
